<form [formGroup]="basketForm">
  <div class="basket-creation">
    
    <div class="editor-header">
      <div class="basket-title center-title">
        <h3>Create New Basket</h3>
      </div>
      <div class="header-spacer"></div>
    </div>

    <div class="editor-layout">
      <div class="left-panel">

        <div class="metadata-section">
          <h4>Basket Metadata</h4>

          <div class="form-grid">

            <mat-form-field appearance="outline">
              <mat-label>Basket Name</mat-label>
              <input matInput formControlName="basketName">
              <mat-error *ngIf="basketForm.get('basketName')?.hasError('required') && basketForm.get('basketName')?.touched">
                Basket Name is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Type</mat-label>
              <mat-select formControlName="basketType">
                <mat-option *ngFor="let t of typeOptions" [value]="t.value">
                  {{ t.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="basketForm.get('basketType')?.hasError('required') && basketForm.get('basketType')?.touched">
                Basket Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Group</mat-label>
              <mat-select formControlName="basketGroup">
                <mat-option *ngFor="let g of groupOptions" [value]="g.value">
                  {{ g.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="basketForm.get('basketGroup')?.hasError('required') && basketForm.get('basketGroup')?.touched">
                Basket Group is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>MedDRA-Version</mat-label>
              <input matInput formControlName="meddraVersion" readonly>
              <mat-error *ngIf="basketForm.get('meddraVersion')?.hasError('required') && basketForm.get('meddraVersion')?.touched">
                MedDRA Version is required
              </mat-error>
            </mat-form-field>

          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="basketDescription" rows="3"></textarea>
          </mat-form-field>
        </div>

        <!-- SELECTION PANEL -->
        <div class="selection-panel" *ngIf="selectedItems.length > 0">
          <div class="selection-header">
            <h5>Selected Items ({{ selectedItems.length }})</h5>
            <button mat-button (click)="clearAllSelections()">
              Clear All
            </button>
          </div>
          <div class="selection-list">
            <div
              *ngFor="let item of selectedItems; let i = index"
              class="selected-item"
              [ngClass]="getProvenanceClass(item)"
            >
              <span class="item-name">{{ item.name || item.term }}</span>
              <span class="item-code">{{ item.code }}</span>
              <span class="item-level">{{ item.level }}</span>
              <button class="remove-btn" (click)="removeSelection(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </div>


        <div class="action-buttons">
          <div class="left-buttons">
        
              <app-common-button
                label="Back"
                title="Back"
                [buttonId]="1111"
                [variant]="'cancel'"
                style="margin-bottom: 1rem;"
                (clicked)="closeEditor()"
                ></app-common-button>
          </div>
          <div class="right-buttons">
            
           <app-common-button
               
                label="Save Draft"
                title="Save Draft"
                [buttonId]="1111"
                [variant]="'primary'"
                style="margin-bottom: 1rem;"
                (clicked)="saveBasket()"
              >
              </app-common-button>
            <app-common-button
                label="Submit"
                title="Submit for Review"
                [buttonId]="1111"
                [variant]="'primary'"
                style="margin-bottom: 1rem;"
                (clicked)="submitForReview()"
              >
              </app-common-button>
                    <app-common-button
                *ngIf="hasPublishPermission"
                label="Publish"
                title="Publish"
                [buttonId]="1111"
                [variant]="'primary'"
                style="margin-bottom: 1rem;"
                (clicked)="publishBasket()"
              >
              </app-common-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>